var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMouseScroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mousedown",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "78px",
    height: "180px",
    viewBox: "0 0 78 156.896",
    enableBackground: "new 0 0 78 156.896",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t \t#mousedown .circle path{\n\t\t\tposition:relative;\n\t\t\tanimation:_updown 1.5s ease infinite forwards; \n\t\t \n\t\t\t\n\t \t}\n\t \t#mousedown .arrow path{\n\t\t\tposition:relative;\n\t\t\tanimation:_updownarrow 1.5s ease infinite forwards; \n\t \n\t\t\t\n\t \t}\n\n\t \t@keyframes _updown{\n\t\t\t0%{\n\t\t\t transform: translateY(0%)\n\t\t\t}\n\t\t\t50%{\n\t\t\t transform: translateY(40%)\n\t\t\t},\n\t\t\t100%{\n\t\t\t transform: translateY(0%)\n\t\t\t}\n\t \t}\n\t \t@keyframes _updownarrow{\n\t\t\t0%{\n\t\t\t transform: translateY(0%)\n\t\t\t}\n\t\t\t50%{\n\t\t\t transform: translateY(7%)\n\t\t\t},\n\t\t\t100%{\n\t\t\t transform: translateY(0%)\n\t\t\t}\n\t \t}\n\n\t ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#cd4b09",
    d: "M39,128c-21.505,0-39-17.495-39-39V39C0,17.495,17.495,0,39,0s39,17.495,39,39v50 C78,110.505,60.505,128,39,128z M39,6C20.804,6,6,20.804,6,39v50c0,18.196,14.804,33,33,33s33-14.804,33-33V39 C72,20.804,57.196,6,39,6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd4b09",
    d: "M38.5,42c-6.065,0-11-4.935-11-11s4.935-11,11-11s11,4.935,11,11S44.565,42,38.5,42z M38.5,25 c-3.309,0-6,2.691-6,6s2.691,6,6,6s6-2.691,6-6S41.809,25,38.5,25z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd4b09",
    d: "M37.777,156.214l-14.289-14.289c-0.91-0.909-0.91-2.383,0-3.292c0.908-0.908,2.382-0.908,3.291,0l12.644,12.645 l12.643-12.644c0.909-0.909,2.382-0.909,3.292,0c0.909,0.908,0.909,2.382,0,3.291l-14.289,14.289 c-0.455,0.454-1.05,0.682-1.645,0.682C38.827,156.896,38.231,156.668,37.777,156.214z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseScroll);
export default __webpack_public_path__ + "static/media/mouse-scroll.332df3a2a3efe2b8bf7533eb22ba52b5.svg";
export { ForwardRef as ReactComponent };